import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSButton, DDSHeadlineText, DDSIconButton } from "@web-monorepo/dds";
import { IconChevronLeft } from "@web-monorepo/dds-icons";
import { getImageSrc } from "@web-monorepo/static-assets";
import * as React from "react";
import { RemoteSlideProps, Slide } from "./types";
import { resolveText, type SlideText } from "./text";
import styles from "./IntroSlide.module.css";

const decideImage = getImageSrc("toolkit/src/pods/conundrums/assets/decide.png");
const listenImage = getImageSrc("toolkit/src/pods/conundrums/assets/listen.png");
const reflectImage = getImageSrc("toolkit/src/pods/conundrums/assets/reflect.png");

const EmojiBlock: React.FC<{
  image: string;
  text: string;
  className: string;
}> = ({ image, text, className }) => {
  return (
    <span className={className}>
      <div className={styles.emojiImageWrapper}>
        <img src={image} className={styles.emojiImage} alt="" />
      </div>
      <div>{text}</div>
    </span>
  );
};

export const IntroSlide = (
  title: SlideText,
  description: SlideText,
  question: SlideText,
  conundrumImage: string,
  duration?: string,
): Slide => {
  return {
    remote: ({ next, goToTeacherTips }: RemoteSlideProps) => (
      <div className={styles.app}>
        <div>
          <div className={styles.titleRow}>
            <DDSIconButton
              data-name="intro_slide:back"
              aria-label={t`Go back`}
              tooltip={{ content: t`Go back`, dataName: "intro_slide:back:tooltip" }}
              variant="transparent"
              className={styles.backButton}
              onClick={() => next(-1)}
            >
              <IconChevronLeft />
            </DDSIconButton>
            <DDSHeadlineText as="h3" level="sm">
              {resolveText(title)}
            </DDSHeadlineText>
          </div>
          <DDSBodyText as="p" className={styles.description}>
            {resolveText(description)} <b>{resolveText(question)}</b>
          </DDSBodyText>
          <DDSBodyText as="p" level="md" variant="secondary">
            <Trans>{{ duration: duration ? duration : "10-20" }} min activity</Trans>
          </DDSBodyText>

          <img src={conundrumImage} className={styles.image} alt={t`Conundrum`} />
          <div className={styles.tagsWrapper}>
            <div className={styles.tagsRow}>
              <div className={styles.tagsInner}>
                <EmojiBlock image={listenImage} text={t`Listen`} className={styles.tag} />
                <EmojiBlock image={decideImage} text={t`Decide`} className={`${styles.tag} ${styles.centerTag}`} />
                <EmojiBlock image={reflectImage} text={t`Reflect`} className={styles.tag} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.buttonsWrapper}>
          <DDSButton
            data-name="intro_slide:remote:intro_slide.teacher_tips"
            variant="tertiary"
            onClick={goToTeacherTips}
          >
            <Trans>Teacher Tips</Trans>
          </DDSButton>
          <DDSButton data-name="intro_slide:remote:intro_slide.start_now" onClick={() => next()}>
            <Trans>Start Now</Trans>
          </DDSButton>
        </div>
      </div>
    ),
  };
};
